import React, {Fragment} from "react";
import SweetAlertBase from "./SweetAlertBase";
import Icon, { ilsGoalWelcome } from '../Icon';

import "../../../assets/sass/components/modals/sa-welcome.scss";

class SA_Welcome extends SweetAlertBase {

    config = {
        showCancelButton: false,
        confirmButtonText: 'Get Started',
    }

    setHtml = (data) => {
        return (
            <Fragment>
                <div className="sa-welcome-content">
                    <Icon svg={ilsGoalWelcome}/>
                    <h2>Welcome to ScoutAfrique</h2>
                    <p>We promise you the best service and features to make your work simpler and productive.</p>
                </div>
            </Fragment>
        )
    }

    type() {
      return 'md';
    }

    className() {
        return "sa-welcome";
    }

    confirmButtonClasses() {
        return "btn btn-primary btn-xl btn-block";
    }
};

export default SA_Welcome;